import { render, staticRenderFns } from "./ColorCalibrationPrint.vue?vue&type=template&id=56292ece&scoped=true&"
import script from "./ColorCalibrationPrint.vue?vue&type=script&lang=js&"
export * from "./ColorCalibrationPrint.vue?vue&type=script&lang=js&"
import style0 from "./ColorCalibrationPrint.vue?vue&type=style&index=0&id=56292ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56292ece",
  null
  
)

export default component.exports